export default __webpack_public_path__ + "static/media/pasta.d70b6433.jpg";